// HOAD (20/09, 2ª rodada): clicar numa miniatura de cor (sibling) no card de
// produto troca a foto grande no lugar, em vez de navegar pro produto-irmão.
// O link continua indo pro produto de verdade se o JS não rodar (teclado,
// leitor de tela, SEO) — aqui só interceptamos o clique do mouse/toque.
(function () {
  function swap(card, link) {
    var img = card.querySelector('.product-primary-image');
    var titleLink = card.querySelector('.product-card-title');
    var addButtonContainer = card.querySelector('.product-card--add-to-cart-button-container');
    var addButton = addButtonContainer ? addButtonContainer.querySelector('button, quick-view') : null;

    if (img) {
      var src = link.dataset.swapImage;
      // O lazysizes (biblioteca de carregamento preguiçoso) guarda o
      // srcset original em cache interno (marca a imagem com a classe
      // `ls-is-cached`) e o navegador sempre prioriza srcset sobre src
      // quando os dois existem — então só trocar `src` não bastava, a
      // foto antiga continuava vencendo. Removendo srcset/data-srcset por
      // completo, o `src` novo passa a mandar de verdade.
      if (src) {
        img.removeAttribute('srcset');
        img.removeAttribute('data-srcset');
        img.removeAttribute('sizes');
        img.removeAttribute('data-sizes');
        img.src = src;
        img.setAttribute('data-src', src);
      }
      img.classList.remove('lazyload', 'ls-is-cached');
      img.classList.add('lazyloaded');
    }

    // 25/09: os tamanhos do card pertencem ao produto original; ao trocar de cor
    // (produto-irmão) tiram-se os tamanhos e o botão volta a abrir a janela padrão.
    var sizePicker = card.querySelector('[data-hoad-card-sizes]');
    if (sizePicker && link.dataset.swapProductHandle) {
      sizePicker.style.opacity = '0.4';
      fetch('/products/' + link.dataset.swapProductHandle + '.js')
        .then(function (r) {
          return r.json();
        })
        .then(function (produto) {
          var idx = -1;
          produto.options.forEach(function (o, i) {
            var nome = (o.name || o).toLowerCase();
            if (nome === 'tamanho' || nome === 'size') idx = i;
          });
          if (idx < 0) {
            sizePicker.remove();
            return;
          }
          var vistos = [];
          produto.variants.forEach(function (v) {
            if (vistos.indexOf(v.options[idx]) < 0) vistos.push(v.options[idx]);
          });
          var primeira = produto.variants.filter(function (v) {
            return v.available;
          })[0] || produto.variants[0];
          sizePicker.dataset.sizeIndex = idx;
          sizePicker.dataset.baseOptions = JSON.stringify(primeira.options);
          sizePicker.querySelector('[data-hoad-card-variants]').textContent = JSON.stringify(
            produto.variants.map(function (v) {
              return { id: v.id, options: v.options, available: v.available };
            })
          );
          var lista = sizePicker.querySelector('.hoad-card-sizes__list');
          lista.innerHTML = '';
          vistos.forEach(function (tam) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'hoad-card-sizes__btn';
            b.dataset.size = tam;
            b.textContent = tam;
            lista.appendChild(b);
          });
          sizePicker.__hoadMarked = false;
          sizePicker.style.opacity = '';
          if (window.__hoadMarcarEsgotados) window.__hoadMarcarEsgotados(card);
        })
        .catch(function () {
          sizePicker.remove();
        });
    }

    if (titleLink && link.dataset.swapTitle) {
      titleLink.textContent = link.dataset.swapTitle;
      titleLink.href = link.dataset.swapUrl;
    }

    if (addButton) {
      var available = link.dataset.swapAvailable === 'true';
      var purchasable = link.dataset.swapPurchasable === 'true';
      addButton.dataset.productId = link.dataset.swapProductId;
      addButton.dataset.productHandle = link.dataset.swapProductHandle;
      addButton.disabled = !available;
      var textEl = addButton.querySelector('.product-card--add-to-cart-text');
      if (textEl) {
        textEl.textContent = available ? 'Adicionar ao carrinho' : 'Esgotado';
      }
      addButton.classList.toggle('product-card--add-to-cart-button-simple', purchasable);
    }

    var group = card.querySelector('[data-hoad-card-siblings]');
    if (group) {
      group.querySelectorAll('[data-hoad-card-siblings-swatch]').forEach(function (el) {
        el.classList.toggle('is-active', el === link);
      });
    }
  }

  // Captura (3º parâmetro true) em vez de deixar borbulhar até o document:
  // dentro de carrossel nativo (Flickity, usado em featured-collection),
  // o próprio carrossel escuta clique pra distinguir arrasto de toque real
  // e cancela o evento antes dele borbulhar — na fase de captura a gente
  // intercepta primeiro, antes desse cancelamento acontecer.
  document.addEventListener(
    'click',
    function (e) {
      var link = e.target.closest('[data-hoad-card-siblings-swatch]');
      if (!link) return;
      var card = link.closest('product-card');
      if (!card) return;
      e.preventDefault();
      e.stopPropagation();
      swap(card, link);
    },
    true
  );

  // 25/09 (pedido do André): "Adicionar ao carrinho" no card mostra os tamanhos ali
  // mesmo (sem abrir a janela) e escolher o tamanho adiciona direto e abre o carrinho.
  document.addEventListener(
    'click',
    function (e) {
      var chip = e.target.closest('.hoad-card-sizes__btn');
      if (chip) {
        e.preventDefault();
        e.stopPropagation();
        var picker = chip.closest('[data-hoad-card-sizes]');
        var card = chip.closest('product-card');
        if (!picker || !card || chip.classList.contains('is-disabled')) return;
        var script = picker.querySelector('[data-hoad-card-variants]');
        var variants = [];
        var base = [];
        try {
          variants = JSON.parse(script.textContent);
          base = JSON.parse(picker.dataset.baseOptions || '[]');
        } catch (err) {
          return;
        }
        var idx = parseInt(picker.dataset.sizeIndex, 10);
        var size = chip.dataset.size;
        var matches = variants.filter(function (v) {
          return v.options[idx] === size && v.available;
        });
        if (!matches.length) return;
        // Se houver outras opções (ex.: cor), prefere a mesma que o card mostra.
        var best =
          matches.filter(function (v) {
            return v.options.every(function (o, i) {
              return i === idx || base[i] === undefined || base[i] === o;
            });
          })[0] || matches[0];
        if (typeof card.addToCart === 'function') {
          picker.querySelectorAll('.hoad-card-sizes__btn').forEach(function (b) {
            b.classList.toggle('is-selected', b === chip);
          });
          card.addToCart(best.id, chip);
        }
        return;
      }

      var btn = e.target.closest('.product-card--add-to-cart-button');
      if (!btn || btn.disabled) return;
      var ownCard = btn.closest('product-card');
      var ownPicker = ownCard && ownCard.querySelector('[data-hoad-card-sizes]');
      if (!ownPicker) return;
      e.preventDefault();
      e.stopPropagation();
      // Sem tamanho escolhido o botão não adiciona: chama a atenção pros tamanhos.
      ownPicker.classList.remove('is-nudge');
      void ownPicker.offsetWidth;
      ownPicker.classList.add('is-nudge');
    },
    true
  );

  // Marca tamanho esgotado (só visual) assim que o card aparece.
  window.__hoadMarcarEsgotados = marcarEsgotados;
  function marcarEsgotados(root) {
    root.querySelectorAll('[data-hoad-card-sizes]').forEach(function (picker) {
      if (picker.__hoadMarked) return;
      picker.__hoadMarked = true;
      var script = picker.querySelector('[data-hoad-card-variants]');
      var idx = parseInt(picker.dataset.sizeIndex, 10);
      var variants;
      try {
        variants = JSON.parse(script.textContent);
      } catch (err) {
        return;
      }
      picker.querySelectorAll('.hoad-card-sizes__btn').forEach(function (chip) {
        var temEstoque = variants.some(function (v) {
          return v.options[idx] === chip.dataset.size && v.available;
        });
        if (!temEstoque) {
          chip.classList.add('is-disabled');
          chip.setAttribute('aria-disabled', 'true');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      marcarEsgotados(document);
    });
  } else {
    marcarEsgotados(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    marcarEsgotados(e.target);
  });
})();
